import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import P1 from '@base/P1/P1';
import H6 from '@base/H6/H6';
import StarCircleOutline from '@icon/StarCircleOutline';
import Language from '@icon/Language';
import Location from '@icon/Location';
import Credit from '@icon/Credit';
import Dedications from '@icon/Dedications';
import Live from '@icon/Live';
import { breakpoints, Spacings } from '@styles/index';

const Icons = {
  StarCircleOutline,
  Language,
  Location,
  Credit,
  Live,
  Dedications
};

const Highlight = styled.div`
  display: flex;
  align-content: space-between;
  margin-bottom: ${Spacings.SPACING_4B};
`;

const HighlightedText = styled(H6)`
  flex: 1;
  margin-top: -${Spacings.SPACING_1};
  margin-left: ${Spacings.SPACING_3B};
  color: var(--color-text-primary);
  @media only screen and (max-width: ${breakpoints.mobile}) {
    font-size: 14px;
  }
`;

const BaseText = styled(P1)`
  display: inline;
  color: var(--color-text-primary);
`;

const EducatorCredential = ({ icon, highlightedText, baseText, atStart }) => {
  const IconComponent = Icons[icon];
  return (
    <Highlight>
      <IconComponent size="18px" color="var(--color-progress-grey)" />
      <HighlightedText>
        {atStart && highlightedText && `${highlightedText} `}
        {baseText && <BaseText>{baseText}</BaseText>}
        {!atStart && highlightedText && ` ${highlightedText}`}
      </HighlightedText>
    </Highlight>
  );
};

export default EducatorCredential;

EducatorCredential.propTypes = {
  icon: PropTypes.string.isRequired,
  highlightedText: PropTypes.string,
  baseText: PropTypes.string,
  atStart: PropTypes.bool
};

EducatorCredential.defaultProps = {
  highlightedText: null,
  baseText: null,
  atStart: false
};
